import React, { useState, useEffect } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import './Login.css';
import Form, { FORM_INPUT_TYPES } from 'new-ui/Components/Form';
import Button from 'new-ui/Components/Button';
import validatePassword from 'functions/formValidations/validatePassword';
import { authenticationApi } from 'components/Authentication/api';
import useRecaptcha from 'utils/hooks/useRecaptcha';
import { useTranslation } from 'utils/modifiedTranslation';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { AUTH_TYPE_URL_SEARCH_PARAM, RESET_PASSWORD_TOKEN_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { AUTH_TYPE } from 'utils/constants/AuthenticationType';
import { useLocationSearchParameters } from 'utils/hooks/useLocationSearchParameters';

const resetPasswordForm = {
  inputs: {
    password: {
      type: FORM_INPUT_TYPES.PASSWORD,
      placeholder: 'New password',
    },
    repeatPassword: {
      type: FORM_INPUT_TYPES.PASSWORD,
      placeholder: 'Repeat password',
    },
  },
  data: {
    password: '',
    repeatPassword: '',
  },
};

export const ResetPassword = () => {
  const dispatch = useDispatch();
  const [showError, setError] = useState(null);
  const [showSuccess, setSuccess] = useState(null);
  const { recaptcha, getRecaptchaTokenAsync } = useRecaptcha();
  const { t } = useTranslation();
  const { [RESET_PASSWORD_TOKEN_URL_SEARCH_PARAM]: token } = useLocationSearchParameters();

  useEffect(() => {
    if (!token) {
      dispatch(push(ROUTE_PATH[ROUTE_NAME.LOGIN]));
    }
  }, [dispatch, token]);

  const resetPassword = async () => {
    const password = resetPasswordForm?.data?.password;
    const repeatPassword = resetPasswordForm?.data?.repeatPassword;

    if (!password) {
      setError('Please fill password');
      return;
    }

    const passwordError = validatePassword(password);

    if (passwordError) {
      setError(t(passwordError));
      return;
    }

    if (password !== repeatPassword) {
      setError('Please fill password');
      return;
    }

    setError(null);

    const result = await authenticationApi.resetPassword({
      password,
      repeatPassword,
      token,
      recaptchaToken: await getRecaptchaTokenAsync(),
    });

    if (!result || !result.success) {
      setError(t('authentication.error.password_reset_failure'));
      return;
    }

    setSuccess(true);
  };

  return (
    <div className="login center flex">
      {recaptcha}
      <div className="reset-password">
        <div className="login-form">
          <div className="title">Reset Password</div>
          {showSuccess ? (
            <div>
              Password change success, you can now
              {' '}
              <span
                className="link"
                onClick={() => {
                  dispatch(push(`${ROUTE_PATH[ROUTE_NAME.LOGIN]}?${AUTH_TYPE_URL_SEARCH_PARAM}=${AUTH_TYPE.EMAIL}`));
                }}
              >
                login
              </span>
              {' '}
              with your new password
            </div>
          ) : (
            <div>
              <div className="text">
                Please create a new password for your account
              </div>
              <Form
                form={resetPasswordForm}
                onenter={resetPassword}
              />
              {showError ? <div className="login-error">{showError}</div> : null}
              <div className="login-button-holder">
                <Button action={resetPassword} title="Submit" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
